import { EnvironmentModel } from './environment-model';
import { enableAkitaProdMode } from '@datorama/akita';

export const environment: EnvironmentModel = {
  production: true,
  apiUrl: window.location.origin,
};

enableAkitaProdMode();
